<template>
    <ModalCommon :id="`ModalPreviewPartner`" :config="config" :isView="true" @close="handleClose">
        <slot></slot>
    </ModalCommon>
</template>

<script>
export default {
    name: 'ModalPreviewPartner',
    components: {
        ModalCommon: () => import('@/components/Modal/main.vue')
    },
    props: {
        config: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {};
    },
    methods: {
        handleClose() {
            this.config.model = false;
        }
    },
    watch: {}
};
</script>

<style lang="scss" scoped></style>
